import { graphql } from "react-relay";

export const send_draft_invoices_for_block = graphql`
  mutation SendDraftInvoicesForBlockMutation(
    $input: SendDraftInvoicesForBlockInput!
    $startingYear: Int!
    $block: Int!
  ) {
    sendDraftInvoicesForBlock(input: $input) {
      success
      errors
      numberOfInvoicesSent
      totalToSend
      erroredInvoice {
        id
        assignedTo {
          id
          accountNumber
          user {
            firstName
            lastName
            email
          }
        }
      }
      profile {
        id
        totalInvoices(startingYear: $startingYear, block: $block)
        totalAmountInvoiced(startingYear: $startingYear, block: $block)
        totalInvoicesSent(startingYear: $startingYear, block: $block)
        totalAmountPaid(startingYear: $startingYear, block: $block)
        totalInvoicesUnpaid(startingYear: $startingYear, block: $block)
        profileGroup {
          id
          sendDraftsProgress
        }
      }
    }
  }
`;
